<template>
  <div><slot></slot></div>
</template>

<script>
export default {
  props: {
    gridData: Object,
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>
